<template>
    <div class="row">
        <div class="col-12 col-md-9 col-lg-6">
            <div class="row block-border mx-0">
                <div v-if="modifyOffer" class="col-12 col-md-6 px-0">
                    <div>
                        <ob1-tag
                            :label="title"
                            type="subscribed"
                        />
                    </div>

                    <div class="mx-1 ms-md-2 me-md-1">
                        <p class="mb-0">
                            <span class="text-mw"><strong>{{ offerLabel }}</strong></span>
                        </p>
                        <ob1-liens
                            class="pt-0 d-webview-none"
                            :text="modifyOffer.label"
                            :href="modifyOffer.url"
                            :with-arrow="true"
                            data-oevent-category="votre_selection_offre"
                            data-oevent-action="modifier_mon_choix"
                            :data-oevent-label="modifyOffer.url"
                        />
                    </div>
                </div>
                <div v-if="continueWithoutMobile" class="col-12 col-md-6 px-0 bg-gray2 d-webview-none align-items-center position-relative">
                    <div class="d-md-flex">
                        <div class="arrow-bottom d-md-none">
                            <svg width="20px" height="20px" viewBox="0 0 20 20">
                                <g
                                    stroke="none"
                                    stroke-width="1"
                                    fill="none"
                                    fill-rule="evenodd"
                                >
                                    <g transform="translate(-150.000000, -262.000000)" fill="#000000">
                                        <g transform="translate(15.000000, 153.000000)">
                                            <polygon
                                                transform="translate(145.000000, 119.000000) rotate(180.000000) translate(-145.000000, -119.000000) "
                                                points="145 109 155 129 135 129"
                                            />
                                        </g>
                                    </g>
                                </g>
                            </svg>
                        </div>
                        <div class="arrow-right d-none d-md-block">
                            <svg width="20px" height="20px" viewBox="0 0 20 20">
                                <g
                                    stroke="none"
                                    stroke-width="1"
                                    fill="none"
                                    fill-rule="evenodd"
                                >
                                    <g transform="translate(-274.000000, -294.000000)" fill="#000000">
                                        <g transform="translate(27.000000, 248.000000)">
                                            <polygon
                                                transform="translate(257.000000, 56.000000) rotate(90.000000) translate(-257.000000, -56.000000) "
                                                points="257 46 267 66 247 66"
                                            />
                                        </g>
                                    </g>
                                </g>
                            </svg>
                        </div>
                        <div class="ms-1 ms-md-3 me-1 pt-2 pb-0">
                            <div>{{ modifyMobileLabel }}</div>
                            <ob1-liens
                                class="pt-0 py-md-0"
                                :text="continueWithoutMobile.label"
                                :href="continueWithoutMobile.url"
                                :with-arrow="true"
                                data-oevent-category="votre_selection_offre"
                                data-oevent-action="continuer_sans_mobile"
                                :data-oevent-label="continueWithoutMobile.url"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: String,
        offerLabel: String,
        modifyOffer: Object,
        continueWithoutMobile: Object,
        modifyMobileLabel: String,
    }
}
</script>

<style scoped lang="scss">
.arrow-bottom {
    position: absolute;
    left: 50%;
    margin-left: -10px;
    margin-top: -2px;
}

.arrow-right {
    position: absolute;
    top: 50%;
    margin-top: -10px;
}

.block-border {
    border: solid 1px #ccc
}
</style>
